import React from 'react';
import { Clock, IndianRupee, ArrowRight } from 'lucide-react';

const TherapyTypeCard = ({ therapyType, onSelect }) => {
  const { therapy_type, duration, fee, currency } = therapyType;

  // Display name mapping
  const displayNames = {
    'individual': 'Individual Therapy',
    'couple': 'Couple Therapy',
    'family': 'Family Therapy',
    'hypnotherapy': 'Hypnotherapy'
  };

  const displayName = displayNames[therapy_type] ||
    therapy_type.charAt(0).toUpperCase() + therapy_type.slice(1) + ' Therapy';

  // Icon mapping
  const getIcon = () => {
    switch(therapy_type) {
      case 'individual': return '👤';
      case 'couple': return '👥';
      case 'family': return '👨‍👩‍👧‍👦';
      case 'hypnotherapy': return '🧘';
      default: return '💬';
    }
  };

  const currencySymbol = currency === 'INR' ? '₹' : currency;

  return (
    <div
      onClick={() => onSelect(therapy_type)}
      className="bg-white dark:bg-dark-bg-secondary border-2 border-gray-200 dark:border-dark-border rounded-lg p-6 cursor-pointer hover:border-primary-500 hover:shadow-lg transition-all duration-200 group"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="text-4xl">{getIcon()}</div>
        <ArrowRight className="h-5 w-5 text-gray-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all" />
      </div>

      <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text-primary mb-2">
        {displayName}
      </h3>

      <div className="space-y-2">
        <div className="flex items-center text-sm text-gray-600 dark:text-dark-text-secondary">
          <Clock className="h-4 w-4 mr-2" />
          <span>{duration} minutes</span>
        </div>

        <div className="flex items-center text-sm text-gray-600 dark:text-dark-text-secondary">
          <IndianRupee className="h-4 w-4 mr-2" />
          <span>{currencySymbol} {fee}</span>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-dark-border">
        <button className="w-full text-center text-primary-600 dark:text-dark-primary-400 font-medium text-sm group-hover:text-primary-700">
          View Available Slots →
        </button>
      </div>
    </div>
  );
};

export default TherapyTypeCard;
